import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { useEnvironment } from '@/features/environments/contexts/EnvironmentContext'

export const Route = createFileRoute('/_auth/customers/$customerId')({
  component: CustomerLayout,
})

function CustomerLayout() {
  const navigate = useNavigate()
  const { currentEnvironment } = useEnvironment()
  const prevEnvironmentRef = useRef(currentEnvironment?.id)

  useEffect(() => {
    if (
      prevEnvironmentRef.current &&
      prevEnvironmentRef.current !== currentEnvironment?.id
    ) {
      navigate({ to: '/customers' })
      return
    }
    prevEnvironmentRef.current = currentEnvironment?.id
  }, [currentEnvironment?.id, navigate])

  return (
    <div className='container mx-auto py-6'>
      <Outlet />
    </div>
  )
}
